
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-chat/display/message-parts/files-and-images",
      function () {
        return require("private-next-pages/x/react-chat/display/message-parts/files-and-images.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-chat/display/message-parts/files-and-images"])
      });
    }
  